<script setup lang="ts">
import { shallowRef, useTemplateRef } from "vue";
import { VODAFONE_HEADER_CONTENT, resolveBrandConfig } from "@dashboard/brands/brandConfig";
import { useResponsive } from "@composable/useResponsive";

const { logoId, logoHref } = resolveBrandConfig("vodafone");
const { logoTrackingName, supportLink, productLinks } = VODAFONE_HEADER_CONTENT;
const { isMobile } = useResponsive();
const openedMenu = shallowRef(false);
const togglerMenu = useTemplateRef<HTMLElement>("toggler-menu");

function showMenu(): void {
  openedMenu.value = !openedMenu.value;
  // Keep this class after closing for the original CSS reverse animation.
  togglerMenu.value?.classList.add("animate");
}

function closeMenu(): void {
  openedMenu.value = false;
}
</script>

<template>
  <header class="rc-layout" :class="{ open: openedMenu }">
    <div class="hero-container">
      <div class="rc-layout-inner">
        <div class="logo-wrapper flex">
          <div>
            <a
              :id="logoId"
              :href="logoHref"
              class="vodafone-main-logo CId-link-main-logo IId-link-main-logo"
              target="_blank"
              rel="noopener"
              :data-dtm-name="logoTrackingName"
              :aria-label="logoTrackingName"
            />
          </div>
          <ul class="wrapper-link wrapper-link-top">
            <li>
              <a class="support CId-link-support IId-link-support" :href="supportLink.href" target="_blank">{{ supportLink.label }}</a>
            </li>
          </ul>
          <div ref="toggler-menu" class="toggler-menu" @click="showMenu()">
            <span class="toggler-top" />
            <span class="toggler-middle" />
            <span class="toggler-bottom" />
          </div>
        </div>
      </div>
      <div class="under-links" :class="{ show: openedMenu }" @click="closeMenu()">
        <div class="rc-layout-inner">
          <ul v-if="isMobile" class="wrapper-link">
            <li>
              <a class="support CId-link-support IId-link-support" :href="supportLink.href" target="_blank">{{ supportLink.label }}</a>
            </li>
          </ul>
          <ul class="wrapper-link">
            <li v-for="link in productLinks" :key="link.className">
              <a
                :class="[link.className, `CId-link-${link.className}`, `IId-link-${link.className}`]"
                :href="link.href"
                target="_blank"
              >{{ link.label }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="header-mob-overlay" />
    </div>
  </header>
</template>
